export default "__VITE_ASSET__BSBGTlF___"